import { LendingAPIProvider } from './LendingAPIProvider';
import { simpleCheck } from './LendingAPIProviderHelper';

class LendingAPIProviderDE extends LendingAPIProvider {
    deserialisePerson(person) {
        var deserialise = super.deserialisePerson(person);

        simpleCheck(deserialise, person, 'title');

        if (person.monthly_non_business_income) {
            deserialise.monthly_non_business_income =
                (person.monthly_non_business_income &&
                    // parseInt to get rid of any decimals where the form fields do not support decimals
                    parseInt(person.monthly_non_business_income.amount)) ||
                '';
        }

        if (person.monthly_business_income) {
            deserialise.monthly_business_income =
                (person.monthly_business_income &&
                    // parseInt to get rid of any decimals where the form fields do not support decimals
                    parseInt(person.monthly_business_income.amount)) ||
                '';
        }

        if (person.data_transfer_consent) {
            deserialise.data_transfer_consent = person.data_transfer_consent;
        }

        return deserialise;
    }

    serialisePerson(person) {
        var serialised = super.serialisePerson(person);

        simpleCheck(serialised, person, 'title');

        if (person.monthly_non_business_income) {
            serialised.monthly_non_business_income = {
                amount: parseInt(person.monthly_non_business_income)
            };
        }

        if (person.monthly_business_income) {
            serialised.monthly_business_income = {
                amount: parseInt(person.monthly_business_income)
            };
        }

        if (person.data_transfer_consent) {
            serialised.data_transfer_consent = person.data_transfer_consent;
        }

        return serialised;
    }

    deserialiseCompany(company) {
        var deserialised = super.deserialiseCompany(company);

        simpleCheck(deserialised, company, 'trading_address');

        if (company.creditreform_id) {
            deserialised.crefo_id = company.creditreform_id;
        }

        if (company.type) {
            deserialised.type = company.type;
        }

        if (company.registered_address) {
            deserialised.address = deserialiseRegisteredCompanyAddress(
                company.registered_address
            );
        }

        if (company.company_number) {
            const companyNumber = deserialiseCompanyNumber(
                company.company_number
            );

            deserialised.company_number = companyNumber.company_number;
            deserialised.company_number_type =
                companyNumber.company_number_type;
        }
        return deserialised;
    }

    serialiseCompany(company) {
        var serialised = super.serialiseCompany(company);

        simpleCheck(serialised, company, 'trading_address');

        if (company.type) {
            serialised.type = company.type;
        }

        if (company.crefo_id) {
            serialised.creditreform_id = company.crefo_id;
        }

        if (company.address) {
            serialised.registered_address = serialiseRegisteredCompanyAddress(
                company.address
            );
        }

        if (company.company_number && company.company_number_type) {
            serialised.company_number = serialiseCompanyNumber(
                company.company_number,
                company.company_number_type
            );
        }
        return serialised;
    }
}

function deserialiseRegisteredCompanyAddress(companyAddress) {
    const deserialisedRegisteredCompanyAddress = {};

    if (companyAddress.building_number) {
        deserialisedRegisteredCompanyAddress.building_number =
            companyAddress.building_number;
    }

    if (companyAddress.street_line_1) {
        deserialisedRegisteredCompanyAddress.street_line_1 =
            companyAddress.street_line_1;
    }

    if (companyAddress.postcode) {
        deserialisedRegisteredCompanyAddress.postcode = companyAddress.postcode;
    }

    if (companyAddress.town) {
        deserialisedRegisteredCompanyAddress.town = companyAddress.town;
    }

    return deserialisedRegisteredCompanyAddress;
}

function serialiseRegisteredCompanyAddress(companyAddress) {
    const serialisedRegisteredCompanyAddress = {};

    if (companyAddress.building_number) {
        serialisedRegisteredCompanyAddress.building_number =
            companyAddress.building_number;
    }

    if (companyAddress.street_line_1) {
        serialisedRegisteredCompanyAddress.street_line_1 =
            companyAddress.street_line_1;
    }

    if (companyAddress.postcode) {
        serialisedRegisteredCompanyAddress.postcode = companyAddress.postcode;
    }

    if (companyAddress.town) {
        serialisedRegisteredCompanyAddress.town = companyAddress.town;
    }

    return serialisedRegisteredCompanyAddress;
}

function serialiseCompanyNumber(companyNumber, companyNumberType) {
    return `${companyNumberType + companyNumber}`;
}

function deserialiseCompanyNumber(companyNumber = '') {
    return {
        company_number_type: companyNumber.substring(0, 3),
        company_number: companyNumber.substring(3)
    };
}

export { LendingAPIProviderDE };
